import { FC } from "react";

import { Col, Space } from "@ctra/components";
import { IdaQnAStatus, GenericEventCta } from "@events";

import styles from "./IdaQnAChildEventView.module.less";

export const IdaQnAChildEventView: FC = () => (
  <Col flex={1} className={styles.Content}>
    <Space direction="vertical" size="small">
      <IdaQnAStatus expanded={true} />
      <GenericEventCta />
    </Space>
  </Col>
);
